module.exports = __webpack_public_path__ + "img/mogujie.b6b565e1.png";